export type PageExtensions = string[]
